import lazySizes from 'lazysizes';
import 'lazysizes/plugins/native-loading/ls.native-loading';

export default function () {
  lazySizes.cfg.nativeLoading = {
    setLoadingAttribute: true,
  };
}
